import StaffNotesPanel from './StaffNotesPanel';
import React from "react";
import EditFormDialog from "../../../shared/components/EditFormDialog";
import { UserCircle } from "../../../shared/assets/AppIcons";
import StaffFormFields from "./StaffFormFields";
import { isInternalStaff } from "../utils/staff.helpers";

export default function EditStaffDialog({ member, onSave, onClose }) {
  if (!member || isInternalStaff(member)) return null;
  return (
    <EditFormDialog
      open
      title="Modifica membro esterno"
      icon={UserCircle}
      className="party-form-dialog"
      formClassName="party-form"
      comments={<StaffNotesPanel staffMember={member} />}
      initialValue={{ ...member, firstName: member.firstName || member.name?.trim().split(/\s+/)[0] || '',
        lastName: member.lastName || member.name?.trim().split(/\s+/).slice(1).join(' ') || '' }}
      onSave={value => onSave({ ...value, name: [value.firstName, value.lastName].map(part => part.trim()).filter(Boolean).join(' ') })}
      onClose={onClose}
    >
      {({ value, onFieldChange, saving }) => (
        <StaffFormFields value={value} onFieldChange={onFieldChange} splitName disabled={saving} />
      )}
    </EditFormDialog>
  );
}
